/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface LlmConfigurationDeleteTriggerTriggerIdDelete$Params {
  triggerId: number;
}

export function llmConfigurationDeleteTriggerTriggerIdDelete(http: HttpClient, rootUrl: string, params: LlmConfigurationDeleteTriggerTriggerIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, llmConfigurationDeleteTriggerTriggerIdDelete.PATH, 'delete');
  if (params) {
    rb.path('triggerId', params.triggerId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

llmConfigurationDeleteTriggerTriggerIdDelete.PATH = '/LLMConfiguration/DeleteTrigger/{triggerId}';
